/**
 * Plan catalog mirrored client-side so the BillingPage can render the
 * "Choose a plan" matrix without hitting the backend for static data.
 *
 * The variant IDs come from the LS test-mode catalog Anton created
 * 2026-05-14. They match the values configured on the backend under
 * ww.billing.variants.* — single source of truth for both.
 */
export const planTiers = [
    {
        slug: 'solo',
        name: 'Solo',
        monthly: 0,
        annual: 0,
        blurb: 'For hobbyists and solopreneurs. Free forever.',
        features: [
            '3 domains · SSL, DNS, Domain, Blacklist, Cert Transparency',
            '1 email deliverability domain',
            '5 uptime endpoints',
            'Email alerts · 1 team member',
        ],
        variants: { monthly: '1655520', annual: '1655574' },
    },
    {
        slug: 'pro',
        name: 'Pro',
        monthly: 39,
        annual: 374,
        featured: true,
        blurb: 'For small IT teams and growing companies.',
        features: [
            '25 domains · all light monitors',
            '5 email deliverability domains',
            '25 uptime endpoints (1-minute checks)',
            'Email + SMS + Slack + Teams + webhooks',
            '5 team members · API access · audit log',
        ],
        variants: { monthly: '1655625', annual: '1655626' },
    },
    {
        slug: 'business',
        name: 'Business',
        monthly: 99,
        annual: 950,
        blurb: 'For growing orgs and agencies managing multiple brands.',
        features: [
            '100 domains · all light monitors + Website Change',
            '20 email deliverability domains',
            '100 uptime endpoints · 30-second checks available',
            'PagerDuty + Opsgenie + Discord + ConnectWise',
            'Unlimited team · public status pages · priority support',
        ],
        variants: { monthly: '1655632', annual: '1655633' },
    },
    {
        slug: 'msp',
        name: 'MSP / Enterprise',
        monthly: 249,
        annual: 2390,
        blurb: 'Multi-client hierarchy, white-label, HIPAA BAA, dedicated CSM.',
        features: [
            '250+ domains · volume tiers thereafter',
            '100+ email deliverability · 200+ uptime endpoints',
            'MSP tenancy (parent + child orgs) · full white-label',
            'HIPAA BAA · SSO · SCIM · audit export',
            'Dedicated CSM · priority escalation',
        ],
        variants: { monthly: '1655643', annual: '1655644' },
    },
];
export function planForSlug(slug) {
    return planTiers.find((p) => p.slug === slug);
}
